import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Panel } from "@/components/admin/ui";

export default function TrainingProgress({ storeId }) {
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/training/progress${storeId ? `?store_id=${storeId}` : ""}`).then((r) => setD(r.data)).catch(() => setD({ employees: [], total_lessons: 0 })); }, [storeId]);
  if (!d) return <p className="text-neutral-500 text-sm">Loading…</p>;
  return (
    <Panel className="divide-y divide-neutral-100" data-testid="training-progress">
      <div className="p-4 text-xs text-neutral-500">{d.total_lessons} published lessons</div>
      {d.employees.length === 0 && <p className="p-8 text-center text-sm text-neutral-500">No employees found.</p>}
      {d.employees.map((e) => (
        <div key={e.id} className="p-4 flex items-center gap-4" data-testid={`progress-${e.id}`}>
          <div className="w-44 min-w-0"><div className="font-medium truncate">{e.name}</div><div className="text-[11px] text-neutral-500 capitalize">{e.role}</div></div>
          <div className="flex-1 h-2.5 rounded-full bg-neutral-100 overflow-hidden"><div className="h-full bg-emerald-500 transition-all" style={{ width: `${e.percent}%` }}/></div>
          <div className="w-28 text-right text-sm"><b>{e.percent}%</b> <span className="text-neutral-400 text-xs">{e.completed}/{e.total}</span></div>
        </div>
      ))}
    </Panel>
  );
}
